import styled from 'styled-components';

export const ToastTitle = styled.strong`
  display: block;
  font-size: 18px;
`;

export const ToastMessage = styled.span`
  display: block;
  margin-top: 3px;
`;
